export const sharedFr = {
	shared: {
		common: {
			scrollHint: 'Défiler vers le bas',
		},
	},
}
